import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text

@Composable
fun DataProtectionDe() {
    H2 { Text("A. Verantwortlicher") }
    P {
        Text("Wir freuen uns, dass Sie eine Webseite der Volkswagen AG, Berliner Ring 2, 38440 Wolfsburg, eingetragen im Handelsregister des Amtsgerichts Braunschweig unter der Nr. HRB 100484 (\"Volkswagen AG\") besuchen.")
    }
    P {
        Text("Im Folgenden informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten durch die Volkswagen AG im Zusammenhang mit Ihrem Besuch der Webseite.")
    }

    H2 { Text("B. Verarbeitung Ihrer personenbezogenen Daten") }
    Ol {
        Li {
            H3 { Text("Verarbeitung von Protokolldateien") }
            P {
                Text("Bei ihrem Besuch auf unserer Webseite verarbeiten wir die folgenden Protokolldateien von Ihnen, die keinen Rückschluss auf Ihre Person zulassen:")
            }
            Ol {
                Li { Text("das von Ihnen genutzte Betriebssystem, den von Ihnen genutzten Web-Browser,") }
                Li { Text("die Websites, die Sie bei uns besucht haben") }
                Li { Text("sowie das Datum und die Uhrzeit Ihres Besuchs.") }
            }
            P {
                Text("Die Verarbeitung dieser Daten erfolgt gemäß Artikel 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses, Ihnen die Webseite ordnungsgemäß anzeigen zu können. Die Daten werden nach 7 Tagen gelöscht. Die Daten werden nur solange verarbeitet, wie Sie auf unsere Webseite zugreifen.")
            }
        }
        Li {
            H3 { Text("Kontaktformular") }
            P {
                Text("Sie haben die Möglichkeit, über ein Kontaktformular mit uns Kontakt aufzunehmen und eine Anfrage an uns zu richten. In diesem Zusammenhang verarbeiten wir folgende Daten: Name, E-Mail-Adresse, Betreff und Nachricht. Wir verarbeiten Ihre dort angegebenen personenbezogenen Daten, um mit Ihnen Kontakt aufzunehmen und Ihre Anfrage zu bearbeiten (vgl. Art. 6 Abs. 1 lit. b DSGVO).")
            }
            P {
                Text("Wir löschen Ihre Daten, sobald wir Ihre Anfrage zu Ihrer Zufriedenheit beantwortet haben, sofern keine anderen Aufbewahrungsfristen (z. B. steuerliche Aufbewahrungsfristen) entgegenstehen.")
            }
        }
    }

    H2 { Text("C. Einsatz von Cookies und Tracking Tools") }
    H3 { Text("Allgemeine Informationen") }
    P { Text("Diese Webseite setzt keine Cookies oder Tracking Tools ein.") }

    H2 { Text("D. Ihre Rechte") }
    P {
        Text("Ihre nachfolgenden Rechte können Sie gegenüber der Volkswagen AG jederzeit unentgeltlich geltend machen. Weitere Informationen zur Wahrnehmung Ihrer Rechte finden Sie unter Abschnitt F.")
    }
    H3 { Text("Auskunftsrecht") }
    P {
        Text("Sie haben das Recht, von uns Auskunft (Art. 15 DSGVO) über die Verarbeitung Ihrer personenbezogenen Daten zu erhalten.")
    }
    H3 { Text("Berichtigungsrecht") }
    P {
        Text("Sie haben das Recht, von uns die Berichtigung (Art. 16 DSGVO) Sie betreffender unrichtiger bzw. unvollständiger personenbezogener Daten zu verlangen.")
    }
    H3 { Text("Recht auf Löschung") }
    P {
        Text("Sie haben das Recht, bei Vorliegen der in Art. 17 DSGVO genannten Voraussetzungen, die Löschung Ihrer Daten zu verlangen. Danach können Sie beispielsweise die Löschung Ihrer Daten verlangen, soweit diese für die Zwecke, für die sie erhoben wurden, nicht mehr notwendig sind. Außerdem können Sie Löschung verlangen, wenn wir Ihre Daten auf der Grundlage Ihrer Einwilligung verarbeiten und Sie diese Einwilligung widerrufen.")
    }
    H3 { Text("Recht auf Einschränkung der Verarbeitung") }
    P {
        Text("Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen, wenn die Voraussetzungen des Art. 18 DSGVO vorliegen. Dies ist beispielsweise der Fall, wenn Sie die Richtigkeit Ihrer Daten bestreiten. Für die Dauer der überprüfung der Richtigkeit der Daten können Sie dann die Einschränkung der Verarbeitung verlangen.")
    }
    H3 { Text("Widerspruchsrecht") }
    P {
        Text("Sofern die Verarbeitung auf einem überwiegenden berechtigten Interesse beruht, haben Sie das Recht, der Verarbeitung Ihrer Daten zu widersprechen. Im Falle des Widerspruchs bitten wir Sie, uns Ihre Gründe mitzuteilen, aus denen Sie der Datenverarbeitung widersprechen. Daneben haben Sie das Recht, der Datenverarbeitung zu Zwecken der Direktwerbung zu widersprechen. Das gilt auch für Profiling, soweit es mit der Direktwerbung zusammenhängt.")
    }
    H3 { Text("Recht auf Datenübertragbarkeit") }
    P {
        Text("Sofern die Datenverarbeitung auf der Grundlage eine Einwilligung oder einer Vertragserfüllung beruht und diese zudem unter Einsatz einer automatisierten Verarbeitung erfolgt, haben Sie das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten und diese an einen anderen Datenverarbeiter zu übermitteln.")
    }
    H3 { Text("Widerrufsrecht") }
    P {
        Text("Sofern die Datenverarbeitung auf einer Einwilligung beruht, haben Sie das Recht, die Einwilligung mit Wirkung für die Zukunft jederzeit kostenlos zu widerrufen.")
    }
    H3 { Text("Beschwerderecht") }
    P {
        Text("Sie haben außerdem das Recht, sich bei einer Aufsichtsbehörde (z. B. bei der Landesbeauftragten für den Datenschutz Niedersachsen) über unsere Verarbeitung Ihrer Daten zu beschweren.")
    }

    H2 { Text("E. Ihre Ansprechpartner") }
    H3 { Text("Ansprechpartner für die Ausübung Ihrer Rechte") }
    P {
        Text("Die Ansprechpartner für die Ausübung Ihrer Rechte und weitergehender Informationen finden Sie auf der folgenden Webseite ")
        A("https://datenschutz.volkswagen.de") { Text("https://datenschutz.volkswagen.de") }
    }
    H3 { Text("Datenschutzbeauftragter") }
    P {
        Text("Unser Datenschutzbeauftragter steht Ihnen als Ansprechpartner für datenschutzbezogene Anliegen zur Verfügung:")
        Br()
        Text("Datenschutzbeauftragter der Volkswagen AG")
        Br()
        Text("Berliner Ring 2")
        Br()
        Text("38440 Wolfsburg")
        Br()
        A("mailto:dataprivacy@volkswagen.de") { Text("dataprivacy@volkswagen.de") }
    }
}


@Composable
fun DataProtectionEn() {
    H2 { Text("A. Controller") }
    P {
        Text("We are pleased that you are visiting a website of Volkswagen AG, Berliner Ring 2, 38440 Wolfsburg, registered in the commercial register of the Braunschweig District Court under the number HRB 100484 (\"Volkswagen AG\").")
    }
    P {
        Text("Below we inform you about the processing of your personal data by Volkswagen AG in connection with your visit to the website.")
    }

    H2 { Text("B. Processing of your personal data") }
    Ol {
        Li {
            H3 { Text("Processing of log files") }
            P {
                Text("When you visit our website, we process the following log files from you, which do not allow any conclusions to be drawn about your person:")
            }
            Ol {
                Li { Text("the operating system you use, the web browser you use,") }
                Li { Text("the websites you visited on our site") }
                Li { Text("as well as the date and time of your visit.") }
            }
            P {
                Text("The processing of this data is carried out in accordance with Article 6 (1) (f) GDPR based on our legitimate interest in being able to display the website properly. The data will be deleted after 7 days. The data will only be processed as long as you access our website.")
            }
        }
        Li {
            H3 { Text("Contact form") }
            P {
                Text("You have the option to contact us via a contact form and send us a request. In this context, we process the following data: name, email address, subject, and message. We process the personal data you provide there to contact you and process your request (cf. Art. 6 (1) (b) GDPR).")
            }
            P {
                Text("We delete your data as soon as we have answered your request to your satisfaction, provided that no other retention periods (e.g., tax retention periods) conflict.")
            }
        }
    }

    H2 { Text("C. Use of cookies and tracking tools") }
    H3 { Text("General information") }
    P { Text("This website does not use cookies or tracking tools.") }

    H2 { Text("D. Your rights") }
    P {
        Text("You can assert your following rights against Volkswagen AG at any time free of charge. Further information on exercising your rights can be found in Section F.")
    }
    H3 { Text("Right to information") }
    P {
        Text("You have the right to obtain information (Art. 15 GDPR) from us about the processing of your personal data.")
    }
    H3 { Text("Right to rectification") }
    P {
        Text("You have the right to request the correction (Art. 16 GDPR) of incorrect or incomplete personal data concerning you.")
    }
    H3 { Text("Right to erasure") }
    P {
        Text("You have the right to request the deletion of your data if the conditions of Art. 17 GDPR are met. For example, you can request the deletion of your data if it is no longer necessary for the purposes for which it was collected. You can also request deletion if we process your data based on your consent and you withdraw this consent.")
    }
    H3 { Text("Right to restriction of processing") }
    P {
        Text("You have the right to request the restriction of the processing of your data if the conditions of Art. 18 GDPR are met. This is the case, for example, if you dispute the accuracy of your data. For the duration of the verification of the accuracy of the data, you can then request the restriction of processing.")
    }
    H3 { Text("Right to object") }
    P {
        Text("If the processing is based on an overriding legitimate interest, you have the right to object to the processing of your data. In the event of an objection, we ask you to inform us of your reasons for objecting to the data processing. In addition, you have the right to object to data processing for direct marketing purposes. This also applies to profiling, insofar as it is related to direct marketing.")
    }
    H3 { Text("Right to data portability") }
    P {
        Text("If data processing is based on consent or the fulfillment of a contract and is also carried out using automated processing, you have the right to receive your data in a structured, common, and machine-readable format and to transfer it to another data processor.")
    }
    H3 { Text("Right to withdraw consent") }
    P {
        Text("If data processing is based on consent, you have the right to withdraw consent at any time free of charge with effect for the future.")
    }
    H3 { Text("Right to lodge a complaint") }
    P {
        Text("You also have the right to lodge a complaint with a supervisory authority (e.g., the State Commissioner for Data Protection of Lower Saxony) about our processing of your data.")
    }

    H2 { Text("E. Your contacts") }
    H3 { Text("Contact persons for exercising your rights") }
    P {
        Text("The contact persons for exercising your rights and further information can be found on the following website ")
        A("https://datenschutz.volkswagen.de") { Text("https://datenschutz.volkswagen.de") }
    }
    H3 { Text("Data Protection Officer") }
    P {
        Text("Our Data Protection Officer is available to you as a contact person for data protection-related concerns:")
        Br()
        Text("Data Protection Officer of Volkswagen AG")
        Br()
        Text("Berliner Ring 2")
        Br()
        Text("38440 Wolfsburg")
        Br()
        A("mailto:dataprivacy@volkswagen.de") { Text("dataprivacy@volkswagen.de") }
    }
}
